import { createApi } from '@reduxjs/toolkit/query/react';
import { fakeBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import BackendApiClient from '../../services/api/BackendApiClient';
import { IMobileApp } from '../../services/exports/Interfaces';

export const mobileAppApiSlice = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'mobileAppApiSlice',
  endpoints: (build) => ({
    getMobileApp: build.query<IMobileApp, string>({
      queryFn: (uuid) =>
        BackendApiClient.request({
          method: 'GET',
          url: `/mobile-apps/${uuid}`,
        }).then((res) => {
          if (res.success) {
            return { data: res.response.data?.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
      keepUnusedDataFor: 600,
    }),
  }),
});

export const { useGetMobileAppQuery } = mobileAppApiSlice;
